// src/utils/apiBase.ts

// Derive the API base from the current host so one build works in every tier:
//   snowbirdindustries.us       -> api.snowbirdindustries.us
//   dev.snowbirdindustries.us   -> dev-api.snowbirdindustries.us
//   beta.snowbirdindustries.us  -> beta-api.snowbirdindustries.us
// Localhost uses the dev API server; anything else falls back to VITE_API_URL.
function resolveApiBase(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:3001/api';
    if (host === 'snowbirdindustries.us') return 'https://api.snowbirdindustries.us/api';
    if (host.endsWith('.snowbirdindustries.us')) {
      const [label, ...rest] = host.split('.');
      return `https://${label}-api.${rest.join('.')}/api`;
    }
  }
  return (
    import.meta.env.VITE_API_URL ||
    (import.meta.env.PROD ? 'https://api.snowbirdindustries.us/api' : 'http://localhost:3001/api')
  );
}

const API_BASE_URL = resolveApiBase();

export default API_BASE_URL;
